import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { RitenutaAccontoPRModalComponent } from './ritenuta-acconto-pr-modal';

export const RitenutaAccontoPRModalModule: string = ng
    .module('ritenuta-acconto-pr-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('ritenutaAccontoPRModalComponent', RitenutaAccontoPRModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/ritenuta-acconto-pr-modal/ritenuta-acconto-pr-modal.module.ts